import { render, staticRenderFns } from "./advance-payment-add-or-update.vue?vue&type=template&id=2a6ca780&scoped=true"
import script from "./advance-payment-add-or-update.vue?vue&type=script&lang=js"
export * from "./advance-payment-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./advance-payment-add-or-update.vue?vue&type=style&index=0&id=2a6ca780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ca780",
  null
  
)

export default component.exports